//详情显示页面接口

import request from "_private/utils/request";

export function fetchGoodsInfo(data) {
  return request({
    url: "/board/warehouseTask/getReservationMessage",
    method: "post",
    headers: { type: "json" },
    data
  });
}
